import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import { BaseComponent } from '../../../modules/tcm-core.module';
import { Subscription } from 'rxjs/internal/Subscription';
import { permissionAreaKeyNameOf, permissionEnityKeyNameOf } from '../../../helpers/permission.helpers';
import { BroadCastEvents } from '../../../common/broad-cast-events.enum';
import { AdminArea } from '../../../models/roles';
import { SecureBaseComponentContext } from '../../../modules/tcm-common/services/secure-base-component-context.service';
import { BrandInfoWidgetRequest, BrandInfoWidgetViewModel } from '../../../models/brands';
import { UpdateBrandLogoComponent } from './update-logo/update-brand-logo.component';
import { BaseComponent } from '../../tcm-core.module/components/base-component/base-component.component';

@Component({
    selector: 'brand-info-widget',
    templateUrl: './brand-info-widget.component.html',
    styleUrls: ['./brand-info-widget.component.scss'],
    standalone: false
})
export class BrandInfoWidgetComponent extends BaseComponent<BrandInfoWidgetRequest, BrandInfoWidgetViewModel> {

  private updateSubscription: Subscription;
  private permissionsSubscription: Subscription;
  public canUpdatePhoto = true;

  constructor(
    protected override componentContext: SecureBaseComponentContext, protected override route: ActivatedRoute) {

    super(componentContext, route);

    this.actionName = 'BrandWidget/InfoWidget';

    this.updateSubscription = this.componentContext.broadcastService
      .getEvents(BroadCastEvents.BrandLogoChanged, BroadCastEvents.BrandChanged)
      .subscribe(e => {
        if (e.name == BroadCastEvents.BrandLogoChanged) {
          this.viewModel.logo = e.args.src;
        } else {
          this.refresh();
        }
      });

    this.permissionsSubscription = this.componentContext.permissionService
      .getEntityPermissions$(permissionAreaKeyNameOf('admin'), permissionEnityKeyNameOf<AdminArea>('brands'))
      .subscribe(x => {
        this.canUpdatePhoto = x && x.canEdit === true;
      });
  }

  public openUplaodLogoModal($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.componentContext.modalService.openComponentInModal(UpdateBrandLogoComponent, "sm", { requestModel: { brandId: this.requestModel.brandId } });
  }

  protected createRequestModel(): BrandInfoWidgetRequest {
    return {} as BrandInfoWidgetRequest;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.updateSubscription.unsubscribe();
    this.permissionsSubscription.unsubscribe();
  }
}
